import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService, HttpBaseService, LocalizationService, NotifyService } from '@app/core';
import { ApiControllerEnum } from '@app/shared/common/enums';
import { Observable } from 'rxjs';
import { ApplicationListItem, ApplicationWithApplicantListItem } from '../models/application-list-item';
import { ApplicationDetailListItem } from '../models/application-detail-list-item';

@Injectable({
  providedIn: 'root'
})
export class ApplicationService extends HttpBaseService {

  constructor(private http: HttpClient
    , private notifyServ: NotifyService
    , private localizationService: LocalizationService
    , private configService: ConfigurationService) {
    super(http, ApiControllerEnum.Application, notifyServ, localizationService, configService);
  }

  GetDataByFilterWithApplicant(filter: any): Observable<ApplicationWithApplicantListItem> {
    return this.post("GetDataByFilterWithApplicant", filter, true);
  }

  IncreaseUsageAndUpdatePaymentStatus(applicationID: string): Observable<any> {
    return this.get("IncreaseUsageAndUpdatePaymentStatus?applicationID=" + applicationID);
  }

  AIBasedReportRequest(filter: any): Observable<any> {
    return this.post("AIBasedReportRequest", filter, true);
  }

  GetApplicationUserInfoData(filter: any): Observable<any> {
    return this.post("GetApplicationUserInfoData", filter, true);
  }

  GetAIBasedStepReportButtonStatus(filter: any): Observable<any> {
    return this.post("GetAIBasedStepReportButtonStatus", filter, true);
  }

  GetCurrentApplicationStepId(filter: any): Observable<any> {
    return this.post("GetCurrentApplicationStepId", filter, true);
  }

  GetDecryptedResultPageApplication(filter: any): Observable<any> {
    return this.post("GetDecryptedResultPageApplication", filter, true);
  }

  GetAIBasedStepReport(filter: any): Observable<any> {
    return this.post("GetAIBasedStepReport", filter, true);
  }

  DownloadDetailPdfFromServer(applicationId: string, lang?: string): Observable<Blob> {
    return this.downloadServerPdf('DetailPdfReport', applicationId, lang);
  }

  DownloadSummaryPdfFromServer(applicationId: string, lang?: string): Observable<Blob> {
    return this.downloadServerPdf('SummaryPdfReport', applicationId, lang);
  }

  DownloadAIPdfFromServer(applicationId: string, lang?: string): Observable<Blob> {
    return this.downloadServerPdf('AIPdfReport', applicationId, lang);
  }

  private downloadServerPdf(endpoint: string, applicationId: string, lang?: string): Observable<Blob> {
    const headers = new HttpHeaders().set('hideSpinner', 'false');
    let url = `${this.getApiUrl(endpoint)}?applicationId=${encodeURIComponent(applicationId)}`;
    if (lang) {
      url += `&lang=${encodeURIComponent(lang)}`;
    }
    // Minutes to ADD to UTC for the viewer's local time (e.g. UTC+03:00 -> +180), so the
    // cover-page "report date" is rendered in the user's timezone instead of UTC.
    const tzOffsetMinutes = -new Date().getTimezoneOffset();
    url += `&tz=${tzOffsetMinutes}`;
    return this.http.get(url, { responseType: 'blob', headers });
  }

  saveBlobAsFile(blob: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => window.URL.revokeObjectURL(url), 0);
  }

}
